module.exports = __webpack_public_path__ + "static/tell-logo-black-85705d73b6e347a3dbb79ae3ee840735.png";